
// React
import React from 'react';

// Components
import Modal2Component from 'shared/components/modal2/Modal2Component';
import InputFieldComponent from 'shared/components/input-field/InputFieldComponent';
import FormComponent from 'shared/components/form/FormComponent';
import PrimaryButtonComponent from 'shared/components/primary-button/PrimaryButtonComponent';

// Styles
import './EditInformationModalComponent.styles.css';

// i18n
import { withTranslation } from 'react-i18next';

// Validators
import { FirstNameValidator , UserNameValidator } from 'shared/validators/SignUpValidator';
import { PhoneValidator } from 'shared/validators/PhoneValidator';
import { DateFormatValidator } from 'shared/validators/DateValidator';
import { EmailRequiredValidator } from 'shared/validators/RequiredValidator';


function EditInformationModalComponent( props ) {

    const formRef = React.createRef();
    
    const formInitialValues = {
        first_name: props.field === 'name' && props.value?.first_name? props.value?.first_name : '',
        last_name: props.field === 'name' && props.value?.last_name? props.value?.last_name : '',
        username:  props.field === 'username' && props.value? props.value : '',
        birthday:  props.field === 'birthday' && props.value? props.value : '',
        email:  props.field === 'email' && props.value? props.value : '',
        phone:  props.field === 'phone' && props.value? props.value : '',
    }
    
    function info (values){
        
        if(values.first_name !== "" && values.last_name !== ""){
            let new_data = { 
                "first_name": values.first_name,
                "last_name": values.last_name,
            }
            props.onNewData( props.field, new_data );                
        }else if(values.birthday !== ""){
            let new_data = { 
                "birthday": values.birthday, 
            }
            props.onNewData( props.field, new_data );
        }else if(values.username !== ""){
            let new_data = { 
                "username": values.username, 
            }
            props.onNewData( props.field ,new_data );
        }else if(values.email !== ""){
            let new_data = { 
                "email": values.email, 
            }
            props.onNewData( props.field ,new_data );
        }else if(values.phone !== ""){
            let new_data = { 
                "phone": values.phone, 
            }
            props.onNewData( props.field ,new_data );
        }
    }

    const getValidator=(field)=>{
        switch (field){
            case 'birthday':
                return DateFormatValidator;

            case 'username':
                return UserNameValidator;

            case 'email':
                return EmailRequiredValidator;

            case 'phone':
                return PhoneValidator;
        
            // no default
        }
    }
    
    return (

        <Modal2Component 
            isOpen={props.isOpen} 
            onClose={props.onClose}
            title={props.t(`settings.editInfoModal.${props.field}`)}
            className={'edit-information-modal'}
        >
            <FormComponent 
                    formInitialValues={formInitialValues} 
                    onSubmit={( values, actions ) => { 
                        console.log('values',values);
                        info(values);
                    }}
                    className="edit-information-modal__form"
                    functionDisabled={ ()=>{} }
                    innerRef={formRef}
                >
                    {props.field === 'name' &&
                    <div>
                        <InputFieldComponent 
                            label={props.t('settings.info.name')} 
                            input_id={'first_name'}
                            field_name={'first_name'}
                            validationFunction={ FirstNameValidator }
                            disabled={false}
                            className=""
                            input_type="text"
                            resetError={ () =>props.resetError( {'field':'first_name', 'error':''} ) }
                            error={ props.errors }
                            message=""
                            placeholder=""
                            defaultValue={props.value?.first_name}
                            //value={nameFieldValue}
                            //onChange={handleChangeName}
                        />
                        <InputFieldComponent 
                            label={props.t('settings.info.lastName')} 
                            input_id={'last_name'}
                            field_name={'last_name'}
                            validationFunction={ FirstNameValidator }
                            disabled={false}
                            className=""
                            input_type="text"
                            resetError={ () =>props.resetError( {'field':'last_name', 'error':''} ) }
                            error={ props.errors }
                            message=""
                            placeholder=""
                            defaultValue={props.value?.last_name}
                            //value={lnameFieldValue}
                            //onChange={handleChangeLname}
                        />
                    </div>
                    }
                    {props.field !== 'name' &&
                        <InputFieldComponent 
                            label={props.t(`settings.info.${props.field}`)} 
                            input_id={props.field}
                            field_name={props.field}
                            validationFunction={ getValidator(props.field) }
                            disabled={false}
                            className=""
                            input_type={props.field === "birthday"? "date" : "text"}
                            resetError={ () =>props.resetError( {'field':props.field, 'error':''} ) }
                            error={ props.errors }
                            message=""
                            placeholder=""
                            defaultValue={props.value}
                            //value={fieldValue}
                            //onChange={handleChange}
                        />
                    }
                    
                    
                </FormComponent>
                <div className="edit-information-modal__form-actions">
                    <PrimaryButtonComponent 
                        type="submit"
                        disabled={false} 
                        onClick={ ()=>{formRef.current.handleSubmit()} }
                        className={'small'}
                    >
                        <span>{props.t('settings.btnSave')}</span>
                    </PrimaryButtonComponent>
                </div>
        </Modal2Component>
    )
}

export default withTranslation(['profile', 'validator'])(EditInformationModalComponent)